import { API_BASE } from 'shared/constants/Api'

export const GET_TOKENS = `${API_BASE}/api/v2/ident-service/auth/sign_in`

export const ZIGNSEC_TOKEN_REQUEST = `${API_BASE}/api/v2/ident-service/auth/authorize_via_zignsec`
export const ZIGNSEC_CABLE = `${API_BASE.replace('https', 'wss')}/api/v2/ident-service/cable`
